import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { Stroke, Style } from 'ol/style';

const VectorCustomLayer = ({ url, zIndex = 0 }) => {
    const olMap = useSelector((state) => state.mapStates.olMap)
    useEffect(() => {
        if (!olMap) return null
        const layer = new VectorLayer({
            source: new VectorSource({
                url: url,
                format: new GeoJSON(),
            }),
            style: new Style({
                stroke: new Stroke({
                    color: '#D25D39',
                    width: 2,
                }),
            }),

        });
        layer.setZIndex(zIndex)

        olMap.addLayer(layer)

        return () => {
            if (olMap) {
                olMap.removeLayer(layer)
            }
        }
    }, [olMap, zIndex, url])

    return null
}

export default VectorCustomLayer
